import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom';
import config from '../../../../config'
import Header from '../../Header';
import Footer from '../../../Pages/Footer';
import '../../../Dashboard/css/swap.css';
import '../../../Dashboard/css/addliquidity.css'
import { Container, Row, Col, Card, Nav, Form, Button, Tabs, Tab, Modal, InputGroup, Toast } from 'react-bootstrap';
import ExchangeIcon from '../../../Pages/Presale/IconBox/ExchangeIcon';
import { LiaAngleDownSolid } from "react-icons/lia";
import { IoIosArrowBack } from "react-icons/io";
import { IoSettingsOutline } from "react-icons/io5";
import { PiWarning } from "react-icons/pi";
import { TbLogout } from "react-icons/tb";
import { LuCopy } from "react-icons/lu";
import { BsPlusLg } from "react-icons/bs";
import { Toaster } from 'react-hot-toast';



const Addliquiditypool = () => {
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const Invalidpair = () => setShow(true);
    const handleShow = () => setShow(true);

    const inputstyle = {
        paddingLeft: "40px",
        backgroundColor: "#85DEF51A",
        border: "1px solid #85DEF51A",
        borderRadius: "10px"
    };

    return (
        <>
        <Toaster/>
            <Header />

            <div className='subheader'>
                <img src='assets/images/liquidity_banner.png' width={`100%`} />
            </div>
            <div className="dashboard pt-5 pb-5 position-relative">

                <section className="pb-5">
                    <Container>
                        <Row className="justify-content-center">
                            <Col lg={6}>
                                <Card className="cardBox ExchangeForm mt-0 ">
                                    <Row>

                                        <Col lg={12}>

                                            <div className='d-flex justify-content-between mb-4 align-items-center'>
                                                <div><Button variant='default' className='bg-transparent border-0 h-auto'><IoIosArrowBack /></Button></div>
                                                <div><h4 className='mb-0'>Add Liquidity</h4></div>
                                                <div><Button variant='default' className='bg-transparent border-0 h-auto'><IoSettingsOutline /></Button></div>

                                            </div>
                                            <Toast className='w-100 rounded-4 mb-4' bg="primary">
                                                <Toast.Body className='fs-6'>Tip: When you add liquidity, you will receive pool tokens representing your position. These tokens automatically earn fees proportional to your share of the pool, and can be redeemed at any time.</Toast.Body>
                                            </Toast>
                                            <Form>
                                                <div className='d-flex d-none justify-content-between text-danger'>
                                                    <div>
                                                        <small className='fw-bold'>Min amount</small>
                                                    </div>
                                                    <div>
                                                        <small className='fw-bold'>0.0004000725</small>
                                                    </div>
                                                </div>
                                                <div className='inputField border border-secondary rounded-4 p-3 pb-0'>
                                                    <Form.Group className="mb-3">

                                                        <div className='d-flex justify-content-between'>
                                                            <div className='w-80'>
                                                                <Form.Label>Pay</Form.Label>
                                                                <div className='position-relative pr-4'>
                                                                    <Form.Control type="text" placeholder="0" className='fs-3 border-0 bg-transparent p-0' />
                                                                    <div className='F-Icon end-0 d-none'>
                                                                        <Button variant='default' className='bg-transparent border-0 text-blue fs-5'>Max</Button>
                                                                    </div>
                                                                </div>

                                                            </div>
                                                            <div>
                                                                <Form.Label>Balance: 0</Form.Label>
                                                                <div>
                                                                    <Button variant='default' className='border-0 bg-transparent fs-5 text-uppercase currency_dropdown' onClick={handleShow}><img src='assets/images/coin/eth.svg' style={{ lineHeight: "0" }} width="35px" />&nbsp;Eth <LiaAngleDownSolid /> </Button>
                                                                </div>
                                                            </div>
                                                        </div>

                                                    </Form.Group>

                                                </div>
                                                <div className='exchangeIcon mt-3 mb-3 text-center'>
                                                    <Button variant='default' className='bg-transparent d-none'>
                                                        <ExchangeIcon />
                                                    </Button>
                                                    <Button variant='default' className='bg-transparent'>
                                                        <BsPlusLg />
                                                    </Button>
                                                </div>
                                                <div className='inputField border border-secondary rounded-4 p-3 mb-4 pb-0'>
                                                    <Form.Group className="mb-3" controlId="formBasicEmail">
                                                        <div className='d-flex justify-content-between'>
                                                            <div className='w-80'>
                                                                <Form.Label>Get</Form.Label>
                                                                <div className='position-relative pr-4'>
                                                                    <Form.Control type="text" placeholder="0" className='fs-3 border-0 bg-transparent p-0' />
                                                                    <div className='F-Icon end-0 d-none'>
                                                                        <Button variant='default' className='bg-transparent border-0 text-blue fs-5'>Max</Button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div>
                                                                <Form.Label>Balance: 0</Form.Label>
                                                                <div>
                                                                    <Button variant='default' className='border-0 bg-transparent fs-5 text-uppercase currency_dropdown' style={{ lineHeight: "0" }} onClick={handleShow}><img src='assets/images/coin/infi.svg' width="35px" />&nbsp;INFI <LiaAngleDownSolid /></Button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className='d-none'>
                                                            <small>$172,464.59 <span className='text-danger'><b>(-8.920%)</b></span></small>
                                                        </div>
                                                    </Form.Group>


                                                </div>
                                                {/* ------------------- */}
                                                <div className='d-flex justify-content-between mb-3 d-none'>
                                                    <div>
                                                        1 1INCH = 0.00019 ETH ($0.341)
                                                    </div>
                                                    <div>
                                                        <Button variant='default' className='border-0 bg-transparent fs-5 text-uppercase fuel text-nowrap' style={{ lineHeight: "0" }} onClick={handleShow}><svg className='fuelIcon' xmlns="http://www.w3.org/2000/svg" width="25" height="31" viewBox="0 0 25 31" fill="none">
                                                            <path d="M24.1548 4.72857L21.7215 2.29524C21.4839 2.0576 21.0989 2.0576 20.8613 2.29524C20.6237 2.53289 20.6237 2.91785 20.8613 3.15544L22.8645 5.15863L20.8613 7.16183C20.7473 7.27589 20.6831 7.43033 20.6831 7.59196V9.41693C20.6831 10.759 21.7744 11.8503 23.1164 11.8503V22.1918C23.1164 22.5274 22.8438 22.8001 22.5081 22.8001C22.1724 22.8001 21.8997 22.5275 21.8997 22.1918V20.9751C21.8997 19.9688 21.0811 19.1502 20.0747 19.1502H19.4665V3.33371C19.4665 1.99167 18.3752 0.900391 17.0331 0.900391H4.86664C3.52466 0.900391 2.43332 1.99167 2.43332 3.33371V25.2334C1.09134 25.2334 0 26.3247 0 27.6668V29.4917C0 29.828 0.272093 30.1001 0.608345 30.1001H21.2914C21.6277 30.1001 21.8998 29.828 21.8998 29.4917V27.6668C21.8998 26.3248 20.8085 25.2334 19.4665 25.2334V20.3669H20.0748C20.4104 20.3669 20.6832 20.6395 20.6832 20.9752V22.1918C20.6832 23.1982 21.5018 24.0168 22.5081 24.0168C23.5145 24.0168 24.3331 23.1982 24.3331 22.1918V5.15869C24.333 4.99707 24.2689 4.84263 24.1548 4.72857ZM3.65001 3.33371C3.65001 2.66303 4.19596 2.11708 4.86664 2.11708H17.0331C17.7038 2.11708 18.2498 2.66303 18.2498 3.33371V25.2334H3.64995L3.65001 3.33371ZM20.6831 27.6667V28.8833H1.21669V27.6667C1.21669 26.996 1.76264 26.4501 2.43332 26.4501H19.4665C20.1371 26.4501 20.6831 26.996 20.6831 27.6667ZM23.1164 10.6336C22.4457 10.6336 21.8998 10.0877 21.8998 9.41699V7.84386L23.1164 6.62723V10.6336Z" fill="white" />
                                                            <path d="M16.4254 3.33301H5.47553C5.13928 3.33301 4.86719 3.6051 4.86719 3.94135V11.2526C4.86719 11.5888 5.13928 11.8609 5.47553 11.8609H16.4254C16.7616 11.8609 17.0337 11.5888 17.0337 11.2526V3.9413C17.0337 3.6051 16.7616 3.33301 16.4254 3.33301ZM15.8171 10.6442H6.08382V4.54964H15.8171V10.6442Z" fill="white" />
                                                        </svg>&nbsp;$9.80&nbsp;<LiaAngleDownSolid /></Button>

                                                    </div>
                                                </div>
                                                {/* ------------------- */}
                                                <Container className='pricepool d-none'>
                                                    <div className='mb-3'>
                                                        <h5 className='mb-0'>Prices and pool share</h5>
                                                    </div>

                                                    <Row className='justify-content-between mb-4 text-center'>
                                                        <Col lg={4} md={4} xs={4} className='lh-2'>
                                                            <p className='mb-0 small'>225.666</p>
                                                            <h5 className='mb-0 small'>BUSD per ETH</h5>
                                                        </Col>
                                                        <Col lg={4} md={4} xs={4} className='lh-2'>
                                                            <p className='mb-0 small'>0.00443138</p>
                                                            <h5 className='mb-0 small'>ETH per BUSD</h5>
                                                        </Col>
                                                        <Col lg={4} md={4} xs={4} className='lh-2'>
                                                            <p className='mb-0 small'>25.13%</p>
                                                            <h5 className='mb-0 small'>Share Of Pool</h5>
                                                        </Col>
                                                    </Row>
                                                </Container>

                                                <Button variant='primary' onClick={Invalidpair} className='w-100 fs-5 d-none'>Invalid Pair</Button>
                                                <div className=''>
                                                    <Button variant='primary' onClick={Invalidpair} className='w-100 fs-5'>Approve BUSD</Button>
                                                    <Button variant='default' className='w-100 fs-5 my-2 bg-transparent border-0'>Supply</Button>
                                                </div>
                                            </Form>
                                        </Col>

                                    </Row>
                                </Card>
                            </Col>
                        </Row>
                    </Container>

                </section>
            </div>
            {/* ------------- */}
            {/* <Modal show={show} onHide={handleClose} centered>
                <Modal.Header closeButton>
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Col lg={12}>
                            <div className='text-center'>
                                <button className='btn btn-light fs-5 rounded-circle h-auto p-3'><b>BUS</b></button>
                                <div className='text-danger py-3'>Warning&nbsp;<PiWarning /></div>
                                <Row className='justify-content-center mb-4'>
                                    <Col lg={10}>
                                        <p className='mb-0'>This token isn't traded on leading U.S. centralized exchanges or frequently swapped. Always conduct your own research before trading.</p>
                                    </Col>
                                </Row>
                                <Form.Group className='position-relative'>
                                    <Form.Control
                                        type="text"
                                        disabled
                                        defaultValue="https://goerli.."
                                        className='bg-primary border-0'
                                        style={{ color: "#93D9AC" }}
                                    />
                                    <div className='F-Icon'>
                                        <LuCopy className='me-2' stroke='#93D9AC' />
                                        <TbLogout stroke='#93D9AC' />

                                    </div>
                                </Form.Group>
                                <div className='my-3'>
                                    <Button variant='default' className='bg-transparent border-0 text-blue fs-6'>Learn More</Button>
                                </div>
                                <div className='my-3'>
                                    <Button variant='primary' className='px-5 mb-2 col-lg-6'>I Understand</Button><br />
                                    <Button variant='default' className='bg-transparent border-0'>Cancel</Button>
                                </div>

                            </div>
                        </Col>
                    </Row>

                </Modal.Body>

            </Modal> */}
            {/* ------------- */}
             {/* ------You will receive Start------- */}
             <Modal show={show} onHide={handleClose} centered>
                <Modal.Header closeButton>
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Col lg={12}>
                            <div >
                            <div className='text-center'>
                                <h4 class="mb-3">You Will Receive</h4>
                            </div>
                                <Row className='justify-content-center mb-4'>
                                    <Col lg={6} className='mb-2'>
                                        <h5 className='mb-0'>0.0750358</h5>
                                    </Col>
                                    <Col lg={6} className='text-right mb-2'>
                                    <h5 className='mb-0'>ETH</h5>
                                    </Col>
                                    <Col lg={6} className=''>
                                        <h5 className='mb-0'>0.0750358</h5>
                                    </Col>
                                    <Col lg={6} className='text-right'>
                                    <h5 className='mb-0'>BUS</h5>
                                    </Col>
                                    <Col lg={8} className='my-3'>
                                        <p className='small mb-0'>Output is estimated. If the price changes by more than 1% your transaction will revert</p>
                                    </Col>
                                    <Col lg={4} className='my-3'>
                                    </Col>
                                    <Col lg={6} className='mb-2'>
                                        <h5 className='mb-0 small'>ETH Deposited</h5>
                                    </Col>
                                    <Col lg={6} className='text-right mb-2'>
                                    <h5 className='mb-0 small'>0.005</h5>
                                    </Col>
                                    <Col lg={6} className='mb-2'>
                                        <h5 className='mb-0 small'>BUSD Deposited</h5>
                                    </Col>
                                    <Col lg={6} className='text-right mb-2'>
                                    <h5 className='mb-0 small'>1.12832</h5>
                                    </Col>
                                    <Col lg={6} className='mb-2'>
                                        <h5 className='mb-0 small'>Rates</h5>
                                    </Col>
                                    <Col lg={6} className='text-right mb-2'>
                                    <h5 className='mb-0 small'>1 ETH = 22.57 ETH</h5>
                                    </Col>
                                    <Col lg={6} className='mb-2'>
                                        <h5 className='mb-0'></h5>
                                    </Col>
                                    <Col lg={6} className='text-right mb-2'>
                                    <h5 className='mb-0 small'>1 BUSD = 0.004421 ETH</h5>
                                    </Col>
                                    <Col lg={6} className='mb-2'>
                                        <h5 className='mb-0 small'>Share Of Pool</h5>
                                    </Col>
                                    <Col lg={6} className='text-right mb-2'>
                                    <h5 className='mb-0 small'>25.13%</h5>
                                    </Col>
                                    
                                </Row>
                                <div className=''>
                                    <Button variant='primary' className='px-5 mb-2 w-100 fs-5'>Confirm Supply</Button><br />
                                  
                                </div>

                            </div>
                        </Col>
                    </Row>

                </Modal.Body>

            </Modal>
            {/* -------You will receive End------ */}
            

            <Footer bg="bg-primary" />

        </>
    )
}

export default Addliquiditypool;
